export default __webpack_public_path__ + "static/media/access-time.0746cbfa.svg";